import React from 'react';
import { useTranslation } from 'react-i18next';

import NavigationBar from '../components/NavigationBar';
import Menus from '../components/Menus';
import MediaList from '../components/MediaList';
import Footer from '../components/Footer/Footer';

function Media() {
    const { t } = useTranslation();
    const pageTitle = t('PHOTOS');

    return (
        <div>
            <NavigationBar />
            <h1>{pageTitle}</h1>
            <MediaList mediaKey='PAGE_1' maxItems={50}  isShortLine={true} />
            <Menus />
            <Footer />
        </div>
    );
}

export default Media;
